import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { API_URL } from '../../../lib/const';
import DismissalTermStep from '../components/DismissalTermStep';

function DismissalTermStepPage({
  match,
  backClick,
  onClick,
}) {
  const [loadingDismissalTerm, setLoadingDismissalTerm] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [dismissalTerm, setDismissalTerm] = useState('');

  const { token } = match.params;

  const fetchDismissalTerm = async () => {
    setLoadingDismissalTerm(true);
    try {
      const res = await axios.get(`${API_URL}/eligible-onboardings/${token}/dismissal_term`);
      setLoadingDismissalTerm(false);
      setDismissalTerm(res.data);
    } catch (error) {
      setLoadingDismissalTerm(false);
      toast.error('Ocorreu um erro ao carregar o termo de desistencia. Tente novamente.');
    }
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await axios.post(`${API_URL}/eligible-onboardings/${token}/approve_dismissal_term`);
      onClick();
    } catch (error) {
      setSubmitting(false);
      toast.error('Ocorreu um erro ao aceitar o termo de desistencia. Tente novamente.');
    }
  };

  useEffect(() => {
    fetchDismissalTerm();
  }, []);

  return (
    <DismissalTermStep
      loadingDismissalTerm={loadingDismissalTerm}
      submitting={submitting}
      dismissalTerm={dismissalTerm}
      backClick={backClick}
      onSubmit={handleSubmit}
    />
  );
}

DismissalTermStepPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string,
    }),
  }).isRequired,
  backClick: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default withRouter(DismissalTermStepPage);
